import { initFlowbite } from 'flowbite';
import { initLightbox } from './lightbox';
import { initAutoplayVideo } from './autoplayVideo';
import { initFaqAccordion } from './faq';
import { initMailerLite } from './mailerLite';

// Initialize Flowbite components
document.addEventListener('DOMContentLoaded', function () {
  initFlowbite();
  initLightbox();
  initAutoplayVideo();
  initFaqAccordion();
  initMailerLite();
});